import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { UpdateMarkPublishOrderVo } from '../vo/update-mark-publish-order.model'

/**
 * マーク掲載順更新
 *
 * @export
 * @class UpdateMarkPublishOrder
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateMarkPublishOrder extends PlessJsonResponderSub<any> {
  private voList: UpdateMarkPublishOrderVo[];
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateMarkPublishOrder
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        MarkPublishOrderList: this.voList.map((vo) => {
          return {
            combination: {
              parameter: {
                PublishOrder: vo.publishOrder,
                MarkCode: vo.markCode
              }
            }
          }
        })
      }
    });
  }

  /**
   * API呼び出し
   *
   * @memberof UpdateMarkPublishOrder
   */
  execute(voList: UpdateMarkPublishOrderVo[], successFunc: Function = null): void {
    this.voList = voList;
    this.successFunc = successFunc;
    this.send('updateMarkPublishOrder', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateMarkPublishOrder
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
